import { render, staticRenderFns } from "./main-navbar-update-password.vue?vue&type=template&id=8f57317c"
import script from "./main-navbar-update-password.vue?vue&type=script&lang=js"
export * from "./main-navbar-update-password.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports